import React from 'react';

import { MobileFilter2 } from '../../../filter/MobileFilter2';
import { LivingFacilityFilter } from '../../../../models/Filter';
import { LivingFacilityButtonFilterView } from '../../desktop/living_facility/LivingFacilityButtonFilterView';

interface ILivingFacilityFilter {
    filter: LivingFacilityFilter;
    handleChange: (filter: LivingFacilityFilter) => void;
    classNameGroup?: string;
}

export const MobileLivingFacilityFilterButtonView: React.FC<ILivingFacilityFilter> = ({
    filter,
    handleChange,
    classNameGroup
}) => {
    return (
        <MobileFilter2 filterTitle='Удобства'>
            <LivingFacilityButtonFilterView
                filter={filter}
                handleChange={handleChange}
                classNameGroup={classNameGroup}
            />
        </MobileFilter2>
    );
};
